module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "explicacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "explicacaoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Entendi",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "explicacaoModalLabel"
    }
  }, [_vm._v("\n            Fluxo do Agendamento de Férias\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('ol', [_c('li', [_vm._v("\n                  Você deverá escolher, no calendário, uma data válida para o seu\n                  início de férias e salvá-la.\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                  A data salva não poderá ser alterada.\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                  Essa data proposta será analisada pelo seu chefe direto ou por um\n                  responsável, que poderá aprová-la ou não.\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                  Caso a data escolhida não seja aprovada, você receberá um email\n                  notificando a reprovação, e o seu agendamento de férias ficará\n                  aberto para que você possa escolher uma nova data.\n                ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67f9ac32","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ferias/explicacao-modal.vue
// module id = vzcd
// module chunks = 5